<!-- 已提交的请假列表 -->
<template>
  <div class="main-content">
    <van-nav-bar
      id="titlebar"
      title="已提交的"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="content">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        pull-distance="300"
      >
        <van-empty v-if="isEmpty" description="暂无数据" style="height: 100%" />
        <van-list style="height: 100%">
          <div
            v-for="item in leaveList"
            :key="item.leaveId"
            style="
              display: flex;
              flex-direction: column;
              padding: 10px;
              gap: 6px;
              border-top: 1px solid #ececec;
            "
          >
            <div style="display: flex; flex-direction: row; gap: 10px">
              <span style="align-self: flex-start">请假</span>
              <van-tag plain color="#07C160">{{
                leaveState(item.leaveStatus)
              }}</van-tag>
              <span style="align-self: flex-end; margin-left: auto">{{
                moment(item?.createTimeUx).format("YYYY年MM月DD日 HH点mm分")
                
              }}</span>
            </div>
            <span>请假类型: {{ item?.leaveType === 1 ? "公事" : "私事" }}</span>
            <span>开始时间: {{ moment(item?.startDate, "YYYYMMDDHHmm").format("YYYY年MM月DD日 HH点mm分") }}</span>
            <span>结束时间: {{ moment(item?.endDate, "YYYYMMDDHHmm").format("YYYY年MM月DD日 HH点mm分") }}</span>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getLeaveList } from "@/api/leave";
import moment from "moment";
// 请假类型:1、公事，2:私事
// 请假状态,0:审批中,1:已批准,2:已拒绝）
const leaveList: any = ref([]);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const isEmpty = ref(false);
const leaveState = (params) => {
  if (params === 0) {
    return "审批中";
  }
  if (params === 1) {
    return "已批准";
  }
  if (params === 2) {
    return "已拒绝";
  }
  return "";
};
const onClickLeft = () => {
  history.back();
};
const onRefresh = () => {
  finished.value = false;
  loading.value = true;
  onLoad();
};
const onLoad = () => {
  getLeaveList(null)
    .then((res: any) => {
      if (refreshing.value) {
        refreshing.value = false;
      }
      loading.value = false;
      finished.value = true;
      if (res && res.length > 0) {
        leaveList.value = res;
        isEmpty.value = false;
      } else {
        isEmpty.value = true;
      }
    })
    .catch((error) => {
      isEmpty.value = true;
      finished.value = true;
      loading.value = false;
      refreshing.value = false;
    });
};
onActivated(() => {
  refreshing.value = true;
  onRefresh();
});
</script>

<style scoped>
.main-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
}

.content {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
</style>
